var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.size},[_c('div',{staticClass:"item-type",class:{'active': _vm.active},on:{"click":_vm.clicked}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }